module.exports = __webpack_public_path__ + "static/media/linkedin.1290bdd6.png";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/WhatWeDo/linkedin.png
// module id = 364
// module chunks = 0